<template>
  <div class="row col-hspace form-classic">
    <div class="col-xs-12 col-vbspace">
      <label for="date">Date du baptême</label>

      <DatePicker v-model="info.date" big />
    </div>
    <div class="col-xs-12" v-if="godmother">
      <label for="godmother">Prénom de la marraine</label>
      <input class="classic-input big col-small-vspace col-big-hspace"
        id="godmother"
        v-model="info.godmother"
        type="text"
        @blur="blurAction"
      />
    </div>
    <div class="col-xs-12" v-if="godfather">
      <label for="godfather">Prénom du parrain</label>
      <input class="classic-input big col-small-vspace col-big-hspace"
        id="godfather"
        v-model="info.godfather"
        type="text"
        @blur="blurAction"
      />
    </div>
  </div>
</template>

<script>
import { DatePicker } from '../../utils';

export default {
  components: { DatePicker },

  props: {
    informations: {
      type: Object,
      default: () => {},
    },

    godfather: {
      type: Boolean,
      default: false,
    },

    godmother: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    info: {
      get() { return this.informations; },
      set(val) { this.$emit('change-info', val); },
    },
  },

  methods: {
    blurAction(e) {
      if (e.target.value.length < 1) {
        if (!e.target.classList.contains('error')) {
          e.target.classList.add('error');
        }

        return this.$emit('error');
      }

      e.target.classList.remove('error');
    },
  },

};
</script>
